module.exports = "//static.hsappstatic.net/academy-common-lib/static-1.13785/images/pngs/practical_exercise_thumbnail.png"